import { render, staticRenderFns } from "./KabLoader.vue?vue&type=template&id=26b0977f&"
import script from "./KabLoader.vue?vue&type=script&lang=js&"
export * from "./KabLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports